import Team1 from "../images/team/phebe.jpeg";
import Team2 from "../images/team/tannie.jpeg";
import Team3 from "../images/team/princess.jpeg";
import Team4 from "../images/team/ewa.jpeg";
import Team5 from "../images/team/ifeoluwani.jpeg";
import Team6 from "../images/team/tunmise.jpeg";
import Team7 from "../images/team/joy.jpeg";
import Team8 from "../images/team/suprise.jpeg";
import Team9 from "../images/team/evidence.jpeg";
import Team10 from "../images/team/ara.jpg";
import Team11 from "../images/team/ifeoluwa.jpeg";
import Team12 from "../images/team/oreoluwa.jpeg";
import Team13 from "../images/team/collins.jpeg";
import Team14 from "../images/team/timi.jpeg";






const teamData = [
  {
    Image: Team1,
    name: "Phebe Oyegbami",
    job: "Licensee & Organizer",
    // instagram: "https://www.instagram.com/fiyinfoluwaenis/",
    // twitter: "https://twitter.com/adebolalives",
    // linkedin: "https://www.linkedin.com/in/fiyinfoluwa-enis-071b83195/",
  },
  {
    Image: Team2,
    name: "Tanitoluwa Enis",
    job: "Co-Organizer & Treasurer",
    instagram: "https://www.instagram.com/iam_enistannie/",
    twitter: "https://twitter.com/EnisTanitoluwa",
    linkedin: "https://www.linkedin.com/in/enistanitoluwa/",
  },
  {
    Image: Team3,
    name: "Amarchi Ewuzie",
    job: "Secretary & Operations Lead",
    instagram: "https://www.instagram.com/princessmarachee/?hl=en",
    // twitter: "https://twitter.com/JohnOgunjide",
    linkedin: "https://www.linkedin.com/in/princess-ewuzie-295ab0321/",
  },
  {
    Image: Team4,
    name: "Ewaoluwanimi Omotoso",
    job: "Sponsorship & Pathnership Lead",
    instagram: "https://www.instagram.com/ewaniimi?igsh=N2NsNjNqd2VwdjAz",
    twitter: "https://x.com/yorubabelle?t=iveu9LtttrbgJ0rWNLrU_g&s=09",
    linkedin: "https://www.linkedin.com/in/ewaoluwanimi-omotoso-402325235",
  },
  {
    Image: Team5,
    name: "Ifeouwani Adeleke",
    job: "Finance Lead",
    instagram: "https://www.instagram.com/ife_oluwani18/",
    // twitter: "https://twitter.com/Inemesit_hanson",
    // linkedin: "https://web.facebook.com/profile.php?id=100007496928118",
  },
  {
    Image: Team6,
    name: "Oluwatunmise Olashinde",
    job: "Security & Protocol Lead",
    instagram: "https://www.instagram.com/olashinde_oluwatunmise/?hl=en",
    twitter: "https://x.com/The_Real_Tlash",
    linkedin: "https://www.linkedin.com/in/oluwatunmise-olashinde/",
  },
  {
    Image: Team7,
    name: "Oloyede Joy",
    job: "Walfare & Hospitality Lead",
    instagram: "https://www.instagram.com/jxxoloyede/?hl=en",
    // twitter: "https://twitter.com/Inemesit_hanson",
    // linkedin: "https://web.facebook.com/profile.php?id=100007496928118",
  },
  {
    Image: Team8,
    name: "Suprise Jegede",
    job: "Curator",
    instagram: "https://www.instagram.com/surprisethegreat/?hl=en",
    twitter: "https://x.com/Preeecillia_S",
    linkedin: "https://www.linkedin.com/in/surprise-jegede-359b3026b/",
  },
  {
    Image: Team9,
    name: "Ali Enashinere Evidence",
    job: "Event Management & Logistic Lead",
    instagram: "https://www.instagram.com/e_v_i_d_e_n_c_e_/?hl=en",
    // twitter: "https://twitter.com/Inemesit_hanson",
    // linkedin: "https://web.facebook.com/profile.php?id=100007496928118",
  },
  {
    Image: Team10,
    name: "Araoluwa Tella",
    job: "Social Media Manager",
    // instagram: "https://www.instagram.com/ife_oluwani18/",
    // twitter: "https://twitter.com/Inemesit_hanson",
    // linkedin: "https://web.facebook.com/profile.php?id=100007496928118",
  },
  {
    Image: Team11,
    name: "Olawoore Ifeoluwa",
    job: "Technical Team Lead",
    instagram: "https://www.instagram.com/big_man_jarvis/",
    twitter: "https://x.com/IfeoluwaOlawoo2",
    linkedin: "https://www.linkedin.com/in/olawoore-ifeoluwa-056aa223a/",
  },
  {
    Image: Team12,
    name: "Oreoluwa Owoade Eunice",
    job: "Media & Publicity Lead",
    instagram: "https://www.instagram.com/theoreowoade/?hl=en",
    twitter: "https://x.com/OreO1024VT",
    linkedin: "https://www.linkedin.com/in/eunice-oreoluwa-owoade-1339b3313/",
  },
  {
    Image: Team13,
    name: "Collins Davis",
    job: "Graphics Lead",
    // instagram: "https://www.instagram.com/big_man_jarvis/",
    // twitter: "https://twitter.com/Inemesit_hanson",
    // linkedin: "https://web.facebook.com/profile.php?id=100007496928118",
  },
  {
    Image: Team14,
    name: "Egbetokun Timilehin",
    job: "Web Developer & Media Lead",
    instagram: "https://www.instagram.com/timmy_tee14/",
    twitter: "https://twitter.com/TimmyTee02",
    linkedin: "https://www.linkedin.com/in/egbetokun-timilehin-88a634189/",
  },
 

];
const teamTitle = {
  main_header: "The Team",
  mini_header: "Our Team",
};

export default teamData;
export { teamTitle };
